import styled from "@emotion/styled";
import theme from "../../styles/theme";

type NavProps = {
  isOpened: boolean;
};

export const CapabilityNavigationBase = styled.div<{ scrolledToTop: boolean }>`
  ${theme.largerThan.lg} {
    top: 100px;
    position: sticky;
    background-color: transparent;
  }
`;

export const CapabilityNavigationContent = styled.div`
  position: relative;
  height: ${theme.spacing["8"]};

  ${theme.largerThan.lg} {
    min-height: 100vh;
  }
`;

export const ScrollContainer = styled.div<NavProps>`
  height: ${(props) => (props.isOpened ? "560px" : "36px")};
  overflow: ${(props) => (props.isOpened ? "scroll" : "hidden")};
  padding: ${theme.spacing[1]} 0;
  transition: height 0.2s ease-in;
  position: absolute;
  left: 0;
  right: 0;
  background-color: ${theme.colors.blues["5"]};
  border-radius: ${theme.spacing["1"]};

  ${theme.largerThan.lg} {
    padding: ${theme.spacing[8]} 0;
    overflow-y: scroll;
    scrollbar-color: ${theme.colors.darkBlues[10]};
    scrollbar-width: ${theme.spacing["2"]};
    height: calc(100vh - 165px);
    background-color: transparent;

    ::-webkit-scrollbar {
      width: ${theme.spacing["2"]};
    }

    ::-webkit-scrollbar-track {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.darkBlues[10]};
      border-radius: ${theme.spacing["2"]};
      border: none;
    }
  }
`;

export const PageNav = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  display: flex;
  flex-direction: column;

  @media (min-height: 900px) {
    gap: ${theme.spacing["2"]};
  }
`;

export const Section = styled.a<{ active: Boolean }>`
  display: inline-block;
  color: ${theme.colors.darkBlues[100]};
  text-decoration: none;
  font-size: ${theme.fontSizes[2]};
  position: relative;
  padding: ${theme.spacing[2]} ${theme.spacing[2]};

  ${(props) => props.active && `font-weight: ${theme.fontWeights.semibold};`}

  ${theme.largerThan.lg} {
    padding-left: ${theme.spacing["4"]};
    ${(props) =>
      props.active &&
      `
        &:before {
          content: '';
          position: absolute;
          width: 2px;
          left: 0;
          top: 0;
          bottom: 0;
          background-color: ${theme.colors.darkGreen};
        }
      `}
  }
`;

export const ActiveBorder = styled.div<{ active: Boolean }>``;

export const ArrowContainer = styled.div<NavProps>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: ${(props) => (props.isOpened ? theme.spacing["7"] : `100%`)};
  display: grid;
  align-items: center;
  justify-items: end;

  ${theme.largerThan.lg} {
    display: none;
  }
`;

export const ScrollArrow = styled.i<NavProps>`
  width: ${theme.spacing["7"]};
  transition: transform 0.2s ease-in;
  ${(props) => props.isOpened && `transform: rotate(180deg);`}
`;

export const JumpText = styled.span`
  display: inline-block;
  font-size: ${theme.fontSizes[0]};
  margin-bottom: ${theme.spacing[1]};

  ${theme.largerThan.lg} {
    display: none;
  }
`;
